<template>
  <div class="bg-fa of">
    <section id="index" class="container">
      <h1 class="fl tac"><span class="c-333">麦芽糖乐器小驿站</span></h1>
      <header class="comm-title">
        <h2 class="fl tac">
          <span class="c-333">古筝列表</span>
        </h2>
      </header>
      <ul>
        <li v-for="product in productList" :key="product.id">
          <a
            :class="[
              'orderBtn',
              { current: payOrder.productId === product.id },
            ]"
            @click="selectItem(product.id,product.price,product.pId)"
            href="javascript:void(0);"
            style="width: 100px; height: 220px; display: flex; flex-direction: column; align-items: center;"
          >
            <img 
              :src="product.image" 
              alt="古筝图片" 
              style="width: 100%; height: 120px; object-fit: cover;">
            <div style="padding: 5px; text-align: center;">
              {{ product.pname }}<br>
              ¥{{ product.price / 100 }}
            </div>
          </a>
        </li>
      </ul>

      <!-- 收货信息表单 -->
      <div class="shipping-info">
        <h3>请填写收货信息</h3>
        <el-form :model="shippingInfo" label-width="100px">
          <el-form-item label="收货人姓名">
            <el-input v-model="shippingInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="shippingInfo.phone"></el-input>
          </el-form-item>
          <el-form-item label="收货地址">
            <el-input type="textarea" v-model="shippingInfo.address"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="PaymentChannel_payment-channel-panel">
        <h3 class="PaymentChannel_title">选择支付方式</h3>
        <div class="PaymentChannel_channel-options">
          <!-- 仅保留支付宝 -->
          <div
            :class="[
              'ChannelOption_payment-channel-option',
              { current: payOrder.payType === 'alipay' },
            ]"
            @click="selectPayType('alipay')"
          >
            <div class="ChannelOption_channel-icon">
              <img src="../assets/img/alipay.png" class="ChannelOption_icon" />
            </div>
            <div class="ChannelOption_channel-info">
              <div class="ChannelOption_channel-label">
                <div class="ChannelOption_channel-label">支付宝</div>
                <div class="ChannelOption_sub-label"></div>
                <div class="ChannelOption_check-option"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="payButtom">
        <!-- 新增订单信息展示 -->
        <div class="order-summary" v-if="payOrder.productId">
          <div class="summary-item">
            <span class="label">实付款：</span>
            <span class="value">¥{{ selectedProduct.price / 100 }}</span>
          </div>
          <div class="summary-item">
            <span class="label">寄送至：</span>
            <span class="value">{{ shippingInfo.address }}</span>
          </div>
          <div class="summary-item">
            <span class="label">收货人：</span>
            <span class="value">{{ shippingInfo.name }} {{ shippingInfo.phone }}</span>
          </div>
        </div>

        <el-button
          :disabled="payBtnDisabled || !payOrder.productId ||!shippingInfo.name ||!shippingInfo.phone ||!shippingInfo.address"
          type="warning"
          round
          style="width: 280px; height: 44px; font-size: 18px; margin-top: 20px;"
          @click="toPay()"
        >
          确认支付
        </el-button>
      </div>
    </section>
  </div>
</template>

<script>
import aliPayApi from '../api/aliPay'

export default {
  data() {
    return {
      payBtnDisabled: false, // 确认支付按钮是否禁用
      productList: [
        { id: 1,pId:3, pname: '经典古筝', price: 300000, image: require('@/assets/img/guzheng1.png') },
        { id: 2,pId:3, pname: '豪华古筝', price: 800000, image: require('@/assets/img/guzheng2.png') },
      ], // 古筝列表
      payOrder: {
        // 订单信息
        productId: '', // 商品id
        pId: '', // 商品id
        payType: 'alipay', // 支付方式
        amount:0,
  
      },
      shippingInfo: {
        name: '',
        phone: '',
        address: '',
      },
    }
  },

  methods: {
    // 选择商品
    selectItem(productId,amount,pId) {
      console.log('商品id：' + productId)
      this.payOrder.productId = productId
      this.payOrder.pId = pId
      this.payOrder.amount = amount/100
      console.log(this.payOrder)
    },

    // 选择支付方式
    selectPayType(type) {
      console.log('支付方式：' + type)
      this.payOrder.payType = type
    },

    // 确认支付
    toPay() {
      // 禁用按钮，防止重复提交
      this.payBtnDisabled = true

      // 支付宝支付
      if (this.payOrder.payType === 'alipay') {
        console.log('商品ID:'+this.payOrder.pId);
        console.log('账号:'+this.shippingInfo.phone);
        console.log('金额:'+this.payOrder.amount);
        // 调用支付宝统一收单下单并支付页面接口
        aliPayApi.tradePagePay(this.payOrder.pId,this.shippingInfo.phone,this.payOrder.amount).then((response) => {
          // 将支付宝返回的表单字符串写在浏览器中，表单会自动触发submit提交
          document.write(response.data.formStr)
        })
      }
    },
  },
  computed: {
    selectedProduct() {
      return this.productList.find(p => p.id === this.payOrder.productId) || {}
    }
  },
}
</script>

<style scoped>
.bg-fa {
  min-height: 75vh;
}

.order-summary {
  background: #fffbe6;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #ffe58f;
}

.summary-item {
  margin: 8px 0;
  font-size: 14px;
}

.label {
  color: #666;
  min-width: 60px;
  display: inline-block;
}

.value {
  color: #333;
  font-weight: 500;
}
</style>
